import request from "@/api/http/request";
import {
  SURVEY_TEMPLATE,
  SURVEY_CLOSE,
  SURVEY_STATUS,
  SURVEY_ADD,
  NOTICE_UNREAD_NUM,
  NOTICE_ALL_READ,
  NOTICE_DELETE,
  NOTICE_PAGE_LIST,
  GET_LARK_QR,
} from "@/api/apiConst/survey";

// 类型定义
export interface surveyTemplateType {
  surveyJson: string;
  surveyVersion: string;
}

/** 问卷调查模板请求 */
export function getSurveyTemplate() {
  return request.post<surveyTemplateType>(SURVEY_TEMPLATE);
}
/** 问卷调查关闭 */
export function getSurveyClose() {
  return request.post<surveyTemplateType>(SURVEY_CLOSE);
}
/** 问卷调查状态 */
export type surveyStatusType = "normal" | "tip" | "hidden";
export function getSurveyStatus() {
  return request.post<surveyStatusType>(SURVEY_STATUS);
}
/** 新增问卷调查 */
export function getSurveyAdd(data: {
  surveyJson: object;
  surveyVersion: string;
}) {
  return request.post<surveyTemplateType>(SURVEY_ADD, data);
}

/** 站内信全部已读 */
export function getNoticeAllRead() {
  return request.post(NOTICE_ALL_READ);
}
/** 站内信未读数量 */
export function getNoticeUnread() {
  return request.post<number>(NOTICE_UNREAD_NUM);
}
export interface noticeItemType {
  businessId: string;
  createDate: string;
  createDateFmt: string;
  id: number;
  noticeContent: string;
  // 消息类型 1-通用课上线 2-专项课上线 3-课程完成 4-考试成绩 12预约课程上线
  noticeType: number;
  /** 阅读状态 阅读状态 0-未读 1-已读 */
  readFlag: 0 | 1;
  studentId: string;
  // 跳转课程的业务id
  jumpUrl?:string;
}
/** 站内信列表 */
export function getNoticeList(data: { page: number; size: number }) {
  return request.post<{
    records: noticeItemType[];
    total: number;
  }>(NOTICE_PAGE_LIST, data);
}
/** 站内信删除 */
export function getNoticeDel(data: { businessId: string }) {
  return request.post(NOTICE_DELETE, data);
}

/** 获取官方二维码 */
export function getLarkQR() {
  return request.post<string>(GET_LARK_QR);
}
